window.STOREHERO = window.STOREHERO || {};
STOREHERO.configs = STOREHERO.configs || {};

/** Start config */
STOREHERO.configs.changePreorderProp = {
  tagPrefix: "preorder-",
  propKey: "発送予定日",
};

STOREHERO.configs.automateCartItems = {
  /**
   * A:tagに指定したタグを持つ商品を購入すると、その商品の数だけhandleに
   * 指定した商品がカートに追加されます。
   * 機能を停止したい場合には、disabledをtrueに変更します。
   */
  syncItems: {
    tag: "autosync", // 商品タグ名 / sample product: test0
    handle: "PAYJ5F", // 商品ハンドル名
    disabled: false, //true or false
  },
  /**
   * B:stepに指定した金額以上になると、handleに指定した商品が追加されます。
   * 例えばstepに5000を指定した場合、5,000円以上で1個、10,000円以上で2個カートに追加されます。
   * 機能を停止したい場合には、disabledをtrueに変更します。
   */
  addedAutomaticallyPerPriceThreshold: {
    handle: "PJREVENGERSMIRROR", // 商品ハンドル名
    step: 3300, // 円
    disabled: true, //true or false
  },
  /**
   * C:カート内の商品に、tagsに指定したタグが含まれる場合、
   * noveltyHandleで指定した商品が追加されます。
   * 機能を停止したい場合には、disabledをtrueに変更します。
   */
  noveltyWithCombination: {
    tags: ["jekyll", "hyde"], // 商品タグ名 / sample products: [test3, test4]
    noveltyHandle: "pj3c13a2", // 商品ハンドル名
    disabled: true, //true or false
  },
  /**
   * D:tagに指定したタグを持つ商品がカートに含まれ、かつカートの総額がminAmount以上になると、
   * noveltyHandleに指定した商品を追加します。
   * 機能を停止したい場合には、disabledをtrueに変更します。
   */
  noveltyWithPriceThreshold: {
    tag: "edison", // 商品タグ名 / sample product: test6
    minAmount: 6600, // 円
    noveltyHandle: "pj4e13a", // 商品ハンドル名
      disabled: false, //true or false
  },
};
/** End config */

STOREHERO.changePreorderProp = function (lineItem) {
  const config = this.configs.changePreorderProp;
  const tagPrefix = config.tagPrefix;
  const propKey = config.propKey;

  return fetch("/products/" + lineItem.handle + ".js")
    .then(function (response) {
      return response.json();
    })
    .then(function (product) {
      const tags = product.tags;
      let preorderDate;
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        if (tag.startsWith(tagPrefix)) {
          preorderDate = tag.replace(tagPrefix, "");
          if (preorderDate.length == 8) {
            preorderDate =
              preorderDate.slice(0, 4) +
              "/" +
              preorderDate.slice(4, 6) +
              "/" +
              preorderDate.slice(6, 8);
            break;
          }
        }
      }
      const properties = lineItem.properties || {};
      if (preorderDate && !properties[propKey]) {
        properties[propKey] = preorderDate;
        const headers = new Headers({
          "Content-Type": "application/json",
        });

        const request = {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            id: lineItem.key,
            quantity: lineItem.quantity,
            properties: properties,
          }),
        };
        return fetch("/cart/change.js", request).then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok. /cart/change.js");
          }
          return response.json();
        });
      }
      return Promise.resolve(null);
    });
};

STOREHERO.automateCartItems = function () {
  const config = this.configs.automateCartItems;

  /**
   * type {[productHandle: string]: {quantity: number, isAdd: boolean}}
   */
  let updateItems = {};
  /**
   * type {[productHandle: string]: string[]}
   */
  let productTags = {};

  const utils = {
    /**
     *
     * @param {string} handle
     * @returns
     */
    fetchProduct: function (handle) {
      return fetch("/products/" + handle + ".js").then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok. /products/{handle}.js");
        }
        return response.json();
      });
    },
    addCart: function (items) {
      const headers = new Headers({
        "Content-Type": "application/json",
      });

      const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ items: items }),
      };
      return fetch("/cart/add.js", request).then(function (response) {
        if (!response.ok) {
          throw new Error(response.status + ": " + response.statusText);
        }
        return response.json();
      });
    },
    changeCartItem: function (item) {
      const headers = new Headers({
        "Content-Type": "application/json",
      });

      const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(item),
      };
      return fetch("/cart/change.js", request).then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok. /cart/change.js");
        }
        return response.json();
      });
    },
    /**
     *
     * @param {string} targetTag
     * @param {{[productHandle: string]: string[]}} productTags
     * @returns string[]
     */
    getTaggedHandles: function (targetTag, productTags) {
      const keys = [];
      for (const key in productTags) {
        const tags = productTags[key];
        if (tags.includes(targetTag)) {
          keys.push(key);
        }
      }
      return keys;
    },
    /**
     *
     * @param {string} targetTag
     * @param {{[productHandle: string]: string[]}} productTags
     * @returns boolean
     */
    hasTaggedItem: function (targetTag, productTags) {
      return this.getTaggedHandles(targetTag, productTags).length > 0;
    },
    /**
     *
     * @param {string[]} targetTags
     * @param {{[productHandle: string]: string[]}} productTags
     * @returns boolean
     */
    hasTaggedItemsAll: function (targetTags, productTags) {
      let flattenTags = [];
      for (const key in productTags) {
        const tags = productTags[key];
        flattenTags = flattenTags.concat(tags);
      }
      for (const tag of targetTags) {
        if (flattenTags.indexOf(tag) < 0) {
          return false;
        }
      }
      return true;
    },
  };

  const handlers = {
    syncItems: function (cartItems) {
      const _config = config.syncItems;
      if (_config.disabled) return;
      const targetTag = _config.tag.toLowerCase();
      const tagetHandle = _config.handle.toLowerCase();
      const parentHandles = utils.getTaggedHandles(targetTag, productTags);
      const parentsInCart = parentHandles
        .map(function (handle) {
          return cartItems.find((item) => item.handle === handle);
        })
        .filter(function (v) {
          return v;
        });

      const quantity = parentsInCart.reduce(function (acc, parent) {
        return acc + parent.quantity;
      }, 0);
      const isParentExist = parentsInCart.length > 0;

      const childInCart = cartItems.find((item) => item.handle === tagetHandle);
      switch (isParentExist) {
        case true:
          if (!childInCart || quantity !== childInCart.quantity) {
            updateItems[tagetHandle] = {
              quantity: quantity,
              isAdd: !childInCart,
              key: childInCart && childInCart.key,
            };
          }
          break;

        default:
          if (childInCart) {
            updateItems[tagetHandle] = {
              quantity: 0,
              isAdd: false,
              key: childInCart.key,
            };
          }
          break;
      }
    },
    addedAutomaticallyPerPriceThreshold: function (cartItems, amount) {
      const _config = config.addedAutomaticallyPerPriceThreshold;
      if (_config.disabled) return;
      const targetHandle = _config.handle.toLowerCase();
      const surplus = amount % _config.step;
      const quantity = (amount - surplus) / _config.step;
      const itemInCart = cartItems.find((item) => item.handle === targetHandle);

      switch (true) {
        case quantity > 0:
          if (!itemInCart || itemInCart.quantity !== quantity) {
            updateItems[targetHandle] = {
              quantity: quantity,
              isAdd: !itemInCart,
              key: itemInCart && itemInCart.key,
            };
          }
          break;

        default:
          if (itemInCart) {
            updateItems[targetHandle] = {
              quantity: 0,
              isAdd: false,
              key: itemInCart.key,
            };
          }
          break;
      }
    },
    noveltyWithCombination: function (cartItems) {
      const _config = config.noveltyWithCombination;
      if (_config.disabled) return;
      const targetTags = _config.tags.map((tag) => tag.toLowerCase());
      const targetHandle = _config.noveltyHandle.toLowerCase();
      const satisfied = utils.hasTaggedItemsAll(targetTags, productTags);
      const itemInCart = cartItems.find((item) => item.handle === targetHandle);

      switch (satisfied) {
        case true:
          if (!itemInCart || itemInCart.quantity !== 1) {
            updateItems[targetHandle] = {
              quantity: 1,
              isAdd: !itemInCart,
              key: itemInCart && itemInCart.key,
            };
          }
          break;

        default:
          if (itemInCart) {
            updateItems[targetHandle] = {
              quantity: 0,
              isAdd: false,
              key: itemInCart.key,
            };
          }
          break;
      }
    },
    noveltyWithPriceThreshold: function (cartItems, amount) {
      const _config = config.noveltyWithPriceThreshold;
      if (_config.disabled) return;
      const targetTag = _config.tag.toLowerCase();
      const targetHandle = _config.noveltyHandle.toLowerCase();
      const satisfied =
        amount >= _config.minAmount &&
        utils.hasTaggedItem(targetTag, productTags);

      const itemInCart = cartItems.find((item) => item.handle === targetHandle);

      switch (satisfied) {
        case true:
          if (!itemInCart || itemInCart.quantity !== 1) {
            updateItems[targetHandle] = {
              quantity: 1,
              isAdd: !itemInCart,
              key: itemInCart && itemInCart.key,
            };
          }
          break;

        default:
          if (itemInCart) {
            updateItems[targetHandle] = {
              quantity: 0,
              isAdd: false,
              key: itemInCart.key,
            };
          }
          break;
      }
    },
  };

  return new Promise(function (resolve, reject) {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const items = cart.items;
        const amount = items.reduce(function (acc, item) {
          acc += item.final_line_price / 100;
          return acc;
        }, 0);

        const promises = [];
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const request = utils.fetchProduct(item.handle).catch(function () {
            return null;
          });
          promises.push(request);
        }

        Promise.all(promises).then(function (res) {
          for (const i in res) {
            const product = res[i];
            if (!product) continue;
            // NOTE: remove non-breaking spaces
            productTags[product.handle] = product.tags.map(tag => tag.replace(/[\u200B-\u200D\uFEFF]/g, ''));
          }

          handlers.syncItems(items);
          handlers.addedAutomaticallyPerPriceThreshold(items, amount);
          handlers.noveltyWithCombination(items);
          handlers.noveltyWithPriceThreshold(items, amount);

          const updateHandles = Object.keys(updateItems);
          if (updateHandles.length === 0) {
            // https://proteger.readme.io/v2.0/docs/shopify-sdk-cart-integration
            window.dispatchEvent(new CustomEvent('normalizeCart'));
            return resolve({ cart: cart, updated: false });
          }

          // pdateItemsはkeyがhandle
          // cart apiに渡すためのvariant_idをproducts ajax apiから取得する
          const promises = [];
          for (const i in updateHandles) {
            const handle = updateHandles[i];

            // NOTE: 設定者のタイポでhandleが見つからない場合でも処理が進むように、catchでnullを返す
            const request = utils
              .fetchProduct(handle)
              .then(function (product) {
                /**
                 * NOTE:
                 * Returns true if a product is available for purchase.
                 * Returns false if all of the products variants' inventory_quantity
                 * values are zero or less, and their inventory_policy is not set to
                 * "Allow users to purchase this item, even if it is no longer in stock".
                 */
                const available = product.available;
                const variantId = product.variants[0].id;
                return {
                  handle: handle,
                  available: available,
                  variantId: variantId,
                };
              })
              .catch(function () {
                return null;
              });
            promises.push(request);
          }
          Promise.all(promises).then(function (res) {
            const changeItems = [];
            const addItems = [];
            for (i in res) {
              const product = res[i];
              if (!product) continue;
              if (!product.available) continue;
              const updateItem = updateItems[product.handle];
              if (!updateItem) continue;
              if (updateItem.isAdd) {
                addItems.push({
                  quantity: updateItem.quantity,
                  id: product.variantId,
                });
              } else {
                changeItems.push({
                  quantity: updateItem.quantity,
                  id: updateItem.key,
                });
              }
            }
            // console.log("===== updateItems", updateItems);
            // console.log("===== changeItems", changeItems);
            // console.log("===== addItems", addItems);

            // 設定者のタイポなどにより、更新対象のproductが全て見つからないということがあり得る
            // その場合、更新せず終了する
            if (changeItems.length === 0 && addItems.length === 0) {
              // https://proteger.readme.io/v2.0/docs/shopify-sdk-cart-integration
              window.dispatchEvent(new CustomEvent('normalizeCart'));
              return resolve({ cart: cart, updated: false });
            }
            // NOTE: /cart/change.jsを並列で複数実行すると、
            // それぞれの更新処理結果が干渉して全てのchangeが正しく反映されないため、
            // 直列に実行する必要がある

            const promise =
              addItems.length > 0 ? utils.addCart(addItems) : Promise.resolve();

            changeItems
              .reduce(function (chain, item) {
                return chain.then(function () {
                  return utils.changeCartItem(item);
                });
              }, promise)
              .then(function () {
                return fetch("/cart.js");
              })
              .then(function (response) {
                return response.json();
              })
              .then(function (cart) {
                // https://proteger.readme.io/v2.0/docs/shopify-sdk-cart-integration
                window.dispatchEvent(new CustomEvent('normalizeCart'));
                return resolve({ cart: cart, updated: true });
              })
              .catch(function (error) {
                console.log("error", error);
                fetch("/cart.js")
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (cart) {
                    // https://proteger.readme.io/v2.0/docs/shopify-sdk-cart-integration
                    window.dispatchEvent(new CustomEvent('normalizeCart'));      
                    return resolve({
                      cart: cart,
                      updated: false,
                      error: error,
                    });
                  });
              });
          });
        });
      });
  });
};